// assets/custom-image-protect-soft.js
(() => {
  // Bloque le menu contextuel seulement sur les images
  document.addEventListener(
    "contextmenu",
    (e) => {
      const img = e.target?.closest?.("img");
      if (img) e.preventDefault();
    },
    { capture: true }
  );

  // Empêche le glisser-déposer des images
  document.addEventListener(
    "dragstart",
    (e) => {
      const img = e.target?.closest?.("img");
      if (img) e.preventDefault();
    },
    { capture: true }
  );
})();
